import React from "react"
import PropTypes from "prop-types"
import Footer from "./Reuseable/Footer"
import Navbar from "./Reuseable/Navbar"

import "./bootstrap.min.css"
import "./layout.css"

const Layout = ({ children }) => {
  return (
    <div>
      <Navbar />
      {children}
      <Footer />
    </div>
  )
}

Layout.propTypes = {
  children: PropTypes.node.isRequired,
}

export default Layout
